export default __webpack_public_path__ + "static/elephant-ganz-7f897ed43f47267a4ff6c6aa25eac241.jpg";